// src/services/comisionesService.js
import api from './api'

/**
 * Servicio para gestionar comisiones de vendedores.
 * Todas las llamadas usan la instancia compartida de Axios (api.js).
 */
export const comisionesService = {

  // ── Configuración ────────────────────────────────────────────────────────

  /**
   * Lista las configuraciones de comisión de todos los vendedores.
   */
  async listarConfiguraciones () {
    const res = await api.get('/comisiones/configuracion')
    return res.data
  },

  /**
   * Obtiene la configuración de comisión de un vendedor específico.
   * @param {number} usuarioId
   */
  async getConfiguracion (usuarioId) {
    const res = await api.get(`/comisiones/configuracion/${usuarioId}`)
    return res.data
  },

  /**
   * Crea o actualiza la configuración de comisión de un vendedor.
   * @param {number} usuarioId
   * @param {object} datos  { meta_base_mensual, sueldo_base, activo, rangos: [...] }
   */
  async guardarConfiguracion (usuarioId, datos) {
    const res = await api.post(`/comisiones/configuracion/${usuarioId}`, datos)
    return res.data
  },

  // ── Cálculo ──────────────────────────────────────────────────────────────

  /**
   * Calcula las comisiones del mes para uno o todos los vendedores.
   * @param {object} params  { anio, mes, usuario_id? }
   */
  async calcularMes (params = {}) {
    const res = await api.post('/comisiones/calcular', params)
    return res.data
  },

  // ── Reportes ─────────────────────────────────────────────────────────────

  /**
   * Obtiene el reporte de comisiones de un período.
   * @param {object} filtros  { anio?, mes?, estado? }
   */
  async getReportePeriodo (filtros = {}) {
    const query = new URLSearchParams()
    if (filtros.anio)   query.append('anio',   filtros.anio)
    if (filtros.mes)    query.append('mes',    filtros.mes)
    if (filtros.estado) query.append('estado', filtros.estado)
    const qs = query.toString()
    const res = await api.get(`/comisiones/reporte${qs ? '?' + qs : ''}`)
    return res.data
  },

  /**
   * Obtiene el detalle de facturas que conforman la comisión de un vendedor en un mes.
   * @param {number} usuarioId
   * @param {number} anio
   * @param {number} mes
   */
  async getDetalleComision (usuarioId, anio, mes) {
    const res = await api.get('/comisiones/detalle', {
      params: { usuario_id: usuarioId, anio, mes }
    })
    return res.data
  },

  /**
   * Devuelve las cajas y bancos disponibles para registrar el pago de comisión.
   */
  async getCuentas () {
    const res = await api.get('/comisiones/cuentas')
    return res.data
  },

  /**
   * Valida (aprueba el pago de) una comisión y registra la fuente de pago.
   * @param {object} datos  { comision_id, fuente_pago, caja_id?, banco_id?, observacion? }
   */
  async validarComision (datos) {
    const res = await api.post('/comisiones/validar', datos)
    return res.data
  },

  /**
   * Obtiene el historial de comisiones de un vendedor específico.
   * @param {number} usuarioId
   */
  async getHistorialVendedor (usuarioId) {
    const res = await api.get(`/comisiones/vendedor/${usuarioId}`)
    return res.data
  },

  /**
   * Cambia el estado de una comisión.
   * @param {number} id
   * @param {string} estado  borrador | aprobado | validado | pagado
   */
  async cambiarEstado (id, estado) {
    const res = await api.patch(`/comisiones/${id}/estado`, { estado })
    return res.data
  }
}

export default comisionesService
